<template>
  <div class="lbv-leak-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <div class="col-lg-12 leak-list-header">
            <span class="lbv-page-title">User List</span>
          </div>
          <div class="row secondary lbv-search">
            <form
              class="lbv-search-filter leak-list-form"
              @submit.prevent="fetchUsers"
            >
              <div class="leaklistFilters container">
                <b-row>
                  <b-col cols="6">
                    <b-row>
                      <b-col cols="3">
                        <label>User Role</label>
                      </b-col>
                      <b-col cols="9">
                        <b-form-select
                          id="statusFilter"
                          v-model="roleSelection"
                          class="full-width"
                          @input="fetchUsers"
                          @change.native="onChange"
                        >
                          <option
                            v-for="role in userRoles"
                            v-bind="$attrs"
                            :key="role.id"
                            :value="role.id"
                          >
                            {{ role.name }}
                          </option>
                        </b-form-select>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="6">
                    <b-button
                      class="addUser"
                      variant="primary"
                      @click="addUserClicked"
                    >
                      Add New User
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </form>
          </div>

          <b-table
            striped
            hover
            :items="userList"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template
              slot="username"
              slot-scope="data"
            >
              <b-link
                class="deviceLink"
                @click="showUserDetails(data)"
              >
                {{ data.value }}
              </b-link>
            </template>
            <template
              slot="reset"
              slot-scope="data"
            >
              <b-link
                class="deviceLink"
                @click="reset(data)"
              >
                Reset 2FA
              </b-link>
            </template>
          </b-table>
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="pageNumber === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>

          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
          <div class="current-page">
            Page: {{ pageNumber }}
          </div>

          <b-modal
            id="add-new"
            ref="addNewUser"
            title="Create User"
            ok-variant="primary"
            ok-title="Add User"
            @ok="saveNewUser"
          >
            <div class="col-md-12">
              <b-form-group
                horizontal
                label="*Email:"
                :label-cols="3"
              >
                <b-input
                  v-model="newUser.email"
                  type="email"
                />
              </b-form-group>
              <b-form-group
                horizontal
                label="*Role:"
                :label-cols="3"
              >
                <b-form-select
                  id="statusFilter"
                  v-model="newUser.role"
                  class="full-width"
                >
                  <option
                    disabled
                    :value="null"
                  >
                    Please select...
                  </option>
                  <option
                    v-for="role in userRoles"
                    v-bind="$attrs"
                    :key="role.id"
                    :value="role.id"
                  >
                    {{ role.name }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                horizontal
                label="*Tenant:"
                :label-cols="3"
              >
                <div id="tenantSelection">
                  <select
                    id="selectTenant"
                    v-model="selected"
                    class="custom-select"
                    @change="tenantSelected"
                    @input="fetchTenantsInGroup"
                  >
                    <option
                      disabled
                      value=""
                    >
                      Select tenant
                    </option>
                    <option
                      v-for="tenant in tenants"
                      :value="{ id: tenant.id, name: tenant.name, tenantGroup: tenant.tenant_group_id, tenantGroupName: tenant.tenant_group_name }"
                    >
                      {{ tenant.name }}
                    </option>
                  </select>
                </div>
              </b-form-group>
              <span v-if="tenantGroupName !== ''">
                <b-form-group
                  horizontal
                  label="Tenant Group:"
                  :label-cols="3"
                >
                  <b-form-checkbox
                    v-model="newUser.tenantGroup"
                    :plain="true"
                    value="1"
                    unchecked-value="0"
                    @input="fetchTenantsInGroup"
                  >
                    Grant user tenant- group wide access
                  </b-form-checkbox>
                  <div><strong>{{ tenantGroupName }}</strong></div>
                </b-form-group>
              </span>
              <b-form-group
                horizontal
                label="*Language:"
                :label-cols="3"
              >
                <b-form-select
                  v-model="newUser.language"
                  :options="languages"
                />
              </b-form-group>
            </div>
          </b-modal>

          <b-modal
            id="user-details"
            ref="userDetails"
            title="User Details"
            ok-variant="primary"
            ok-title="Save"
            @ok="updateUser"
          >
            <div class="col-md-12">
              <b-form-group
                horizontal
                label="First Name:"
                :label-cols="3"
              >
                <b-input
                  v-model="selectedUser.first_name"
                  type="text"
                />
              </b-form-group>
              <b-form-group
                horizontal
                label="Last Name:"
                :label-cols="3"
              >
                <b-input
                  v-model="selectedUser.last_name"
                  type="text"
                />
              </b-form-group>
              <b-form-group
                horizontal
                label="Email:"
                :label-cols="3"
              >
                <b-input
                  v-model="selectedUser.username"
                  type="email"
                />
              </b-form-group>
              <b-form-group
                horizontal
                label="Mobile Tel:"
                :label-cols="3"
              >
                <b-input
                  v-model="selectedUser.mobile_number"
                  type="tel"
                />
              </b-form-group>
            </div>
          </b-modal>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import userListMixin from '../mixins/userListMixin'

export default {
  name: 'UserList',
  mixins: [userListMixin]
}
</script>
<style media="screen">
  .lbv-leak-list .leaklistFilters .full-width {
    width: 100% !important;
  }

  .lbv-leak-list .leaklistFilters label {
    font-size: 0.8rem
  }

  .lbv-leak-list .leaklistFilters .push-down {
    margin-top: 1rem;
  }
  .secondary .addUser{
    float: right;
  }
  td.width-100 {
    width: 100px;
    max-width: 100px;
  }

  td.width-250 {
    width: 250px;
    max-width: 250px;
  }

</style>
